export default {
  "general": {
    "from": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["From"])},
    "to": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To"])},
    "reset": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset"])},
    "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
    "results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Results"])},
    "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ok"])},
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search..."])},
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])},
    "roles": {
      "WorkingPerson": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Working Person"])},
      "LabourOfficer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Labour Officer"])},
      "PlantManager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plant Manager"])},
      "1AnvAdmin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1ANV Admin"])},
      "FormManager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form Manager"])},
      "DataMaintainer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data Maintainer"])},
      "ProviderManager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Provider Manager"])}
    },
    "token": {
      "expired": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CAUTION"])},
        "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You session expired, you will be rerouted to the login page on the next navigation. Current changes cannot be saved."])}
      }
    }
  },
  "sidebar": {
    "FormReports": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forms"])},
    "PlantManagment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Locations"])},
    "Users": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users"])},
    "UsersAdditional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Users Additional"])},
    "ProviderManagment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providers"])},
    "Settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])}
  },
  "formReports": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form-Reports"])},
    "grid": {
      "isOpen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished"])},
      "id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])},
      "creatorName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creator"])},
      "ownerName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Owner"])},
      "locationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Location"])},
      "facilityName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facility"])},
      "createdAt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Created at"])},
      "changedAt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changed at"])},
      "finishedAt": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished at"])},
      "activityName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activity"])},
      "categoryName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
      "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Description"])},
      "tooltips": {
        "exportPdf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download as PDF"])},
        "changeOwner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change Owner"])}
      }
    },
    "menu": {
      "pdf": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download as PDF"])},
      "owner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange Plant Manager"])}
    },
    "popups": {
      "owner": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exchange Plant Manager"])},
        "formDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form Details"])},
        "plantDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Location Details"])},
        "creatorDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creator Details"])},
        "selectOwner": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select owner"])},
        "ownerDetails": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current Owner"])}
      },
      "filters": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form Filter"])},
        "type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formtyp"])},
        "GEF": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GEF"])},
        "AFG": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AFG"])},
        "BTB": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["BTB"])},
        "VPB": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["VPB"])},
        "SZF": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SZF"])},
        "FQA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FQA"])},
        "isOpen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished"])},
        "isOpenYes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not Finished"])},
        "isOpenNo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished"])}
      }
    },
    "startingPdfDownload": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form-PDFs is downloading"])}
  },
  "plantManagment": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Locationmanagment"])},
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Location"])},
    "grid": {
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
      "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
      "street": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Street & Housenumber"])},
      "postalcode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ZIP & City"])}
    },
    "popups": {
      "addOrUpdate": {
        "title": {
          "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new Location"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Location"])}
        },
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "street": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Street"])},
        "houseNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Housenumber"])},
        "postalcode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ZIP"])},
        "city": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["City"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
        "latitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Latitude"])},
        "longitude": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Longitude"])},
        "applicationRadius": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application Radius (in km)"])}
      },
      "importPlants": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Location Import"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please upload a valid CSV-File. (1ANAB-format is also valid)"])}
      },
      "plantDetails": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Location Details"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "street": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Street & Housenumber"])},
        "postalcode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ZIP & City"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
        "gps": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GPS-Coordinates"])},
        "noGpsData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No GPS data present"])}
      }
    },
    "exportFilename": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1ANV-Locationexport"])},
    "confirmDeletionSingle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the location '", _interpolate(_named("name")), "'?"])},
    "confirmDeletionMulti": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the ", _interpolate(_named("count")), " selected locations?"])}
  },
  "userManagment": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usermanangment"])},
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New User"])},
    "grid": {
      "firstName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firstname"])},
      "lastName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lastname"])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
      "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
      "roles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roles"])}
    },
    "popups": {
      "addOrUpdate": {
        "title": {
          "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new User"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit User"])}
        },
        "firstname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firstname"])},
        "lastname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lastname"])},
        "ssoIdentifier": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Identifier"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "dialCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dialcode"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
        "roles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roles"])}
      },
      "importUsers": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Import"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please upload a valid CSV-File. (1ANAB-format is also valid, but please click the checkbox)"])},
        "anabUserQuestion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you importing users from a 1ANAB system?"])}
      }
    },
    "exportFilename": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1ANV-Userexport"])},
    "confirmDeletionSingle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the user '", _interpolate(_named("name")), "'?"])},
    "confirmDeletionMulti": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the ", _interpolate(_named("count")), " selected users?"])}
  },
  "userManagmentAdditional": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usermanangment Additional"])},
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New User"])},
    "grid": {
      "firstName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firstname"])},
      "lastName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lastname"])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
      "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
      "roles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roles"])},
      "product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products"])},
      "companyId": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company ID"])},
      "anAbSystemId": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1ANAB System ID"])},
      "anvSystemId": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1ANV System ID"])}
    },
    "popups": {
      "addOrUpdate": {
        "title": {
          "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create new User"])},
          "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit User"])}
        },
        "firstname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firstname"])},
        "lastname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lastname"])},
        "ssoIdentifier": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company Identifier"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "dialCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dialcode"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
        "roles": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roles"])}
      },
      "importUsers": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Import"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please upload a valid CSV-File. (1ANAB-format is also valid, but please click the checkbox)"])},
        "anabUserQuestion": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Are you importing users from a 1ANAB system?"])}
      }
    },
    "exportFilename": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["1ANV-Userexport-Additional"])},
    "confirmDeletionSingle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the user '", _interpolate(_named("name")), "'?"])},
    "confirmDeletionMulti": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the ", _interpolate(_named("count")), " selected users?"])}
  },
  "providerManagement": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providermanagement"])},
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Provider"])},
    "inactiveUsers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inactive Staff"])},
    "grid": {
      "companyName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providername"])},
      "adress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Address"])},
      "companyIdCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID"])}
    },
    "menu": {
      "showStaff": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show Staff"])}
    },
    "popups": {
      "edit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Provider"])},
      "addOrUpdate": {
        "title": {
          "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Provider"])}
        }
      },
      "providerSearch": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providersearch"])},
        "providerList": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["List of known Providers"])},
        "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providername"])},
        "kid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identificationnumber"])},
        "postalCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ZIP"])},
        "city": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["City"])},
        "street": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Street"])},
        "houseNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Housenumber"])},
        "phonePrefix": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact: Dialcode"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact: Phonenumber"])},
        "information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Information"])}
      },
      "selectedSimilarProvider": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Simliar Providers"])},
        "editInsertedData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["edit entered Data"])},
        "chooseAvailableProvider": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select existing Provider"])}
      }
    },
    "confirmDeletionSingle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the provider '", _interpolate(_named("name")), "'?"])},
    "confirmDeletionMulti": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the ", _interpolate(_named("count")), " selected providers?"])}
  },
  "providerManagementDetails": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providerstaffmanagment"])},
    "headline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overview Providerstaff"])},
    "address": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Address"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contact"])},
    "information": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Information"])},
    "lessInfos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["less Details"])},
    "moreInfos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["more Details"])},
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Providerstaff"])},
    "connectedWorker": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Connected Providerstaff"])},
    "grid": {
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
      "admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
      "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
      "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
      "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activ"])},
      "cleared": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enabled"])},
      "reactivate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reactivate"])}
    },
    "popups": {
      "new": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add new Providerstaff"])},
        "gsmSearch": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GSM-Search"])},
        "dialCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dialcode"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])}
      },
      "edit": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Providerstaff"])},
        "companyHasAdmin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providerstaff-Administrator"])},
        "workerData": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Providerstaff Data"])},
        "admin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin"])},
        "firstName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firstname"])},
        "lastName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lastname"])},
        "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "dialCode": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dialcode"])},
        "phoneNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Phonenumber"])},
        "enabling": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enabled"])},
        "inviteAsAdmin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invite as Admin"])},
        "invitationInfo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Admin-Invitation was send"])}
      }
    },
    "confirmDeletionSingle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the staff '", _interpolate(_named("name")), "'?"])},
    "confirmDeletionMulti": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Do you really want to delete the ", _interpolate(_named("count")), " selected staff?"])}
  },
  "settingManagment": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
    "grid": {
      "displayName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
      "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
      "editDate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changed at"])}
    },
    "popups": {
      "editGlobal": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit Setting"])}
      }
    }
  }
}